import { render, staticRenderFns } from "./ViewLead.vue?vue&type=template&id=9a615264&scoped=true&"
import script from "./ViewLead.vue?vue&type=script&lang=js&"
export * from "./ViewLead.vue?vue&type=script&lang=js&"
import style0 from "./ViewLead.vue?vue&type=style&index=0&id=9a615264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a615264",
  null
  
)

export default component.exports